import classNames from 'classnames'
import React from 'react'
import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'

type Props = {
  className?: string
  selected?: boolean
  icon: IconDefinition
  location: string
  tip: string
  external?: boolean
}

export const Tab: React.FC<Props> = ({ className, icon, selected, location, tip, external }) => {
  return !selected ? (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a href={location} className={classNames(styles.container, className)} title={tip} target={external ? '_blank' : undefined} rel={external ? 'noreferrer' : undefined}>
      <FontAwesomeIcon icon={icon} className={styles.icon} />
    </a>
  ) : (
    <div className={classNames(styles.container, className, styles.selected)} title={tip}>
      <FontAwesomeIcon icon={icon} className={styles.icon} />
    </div>
  )
}

export default Tab
